"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
const react_1 = __importStar(require("react"));
const styled_1 = require("./styled");
function Table(args) {
    const { meta, data, onRowClick, selected } = args, props = __rest(args, ["meta", "data", "onRowClick", "selected"]);
    const { variant } = props;
    return (react_1.default.createElement(styled_1.StyledTable, Object.assign({}, props),
        react_1.default.createElement("thead", null,
            react_1.default.createElement("tr", null, meta.map((item, i) => {
                const { key, label, thStyled: Renderer } = item;
                const children = label || key;
                return Renderer ? ((0, react_1.cloneElement)(Renderer, { key: i, as: "th" }, children)) : (react_1.default.createElement("th", { key: i }, children));
            }))),
        react_1.default.createElement("tbody", null, data &&
            data.map((values, i) => {
                const props = {
                    key: i,
                    variant,
                    selected: selected && selected.includes(values),
                };
                onRowClick &&
                    Object.assign(props, { onClick: () => onRowClick(values) });
                return (react_1.default.createElement(styled_1.StyledTableRow, Object.assign({}, props), meta.map(({ key, value, tdStyled: Renderer }, i) => {
                    const children = value ? value(values) : values[key];
                    return Renderer ? ((0, react_1.cloneElement)(Renderer, { key: i, as: "td" }, children)) : (react_1.default.createElement("td", { key: i }, children));
                })));
            }))));
}
exports.Table = Table;
//# sourceMappingURL=main.js.map